import { TASK_LIST } from '../constants/apiEndpoints';
import apiClient from '../lib/apiClient';
import { TaskData } from '../pages/task/types';

export async function fetchTaskList(patient_id: number | undefined): Promise<{
  tasks: {
    medical_history: TaskData[];
    medications_count: number;
    allergies_count: number;
  };
}> {
  const response = await apiClient.get(TASK_LIST, {
    params: { patient_id: patient_id },
  });

  return { tasks: response?.data?.data };
}
